<template>
  <Layout style="height: 100%;width: 100%;">
    <Header class="layout-header-bar" style="height: 45px;line-height: 45px">
      <div class="header-wapper">
        <div class="header-left">
          <Icon type="md-menu" size="28"></Icon>
          <Button type="text" class="header-title" to="/doctor_manage" style='background-color: #0e64c3;color: white'>食疗医生系统</Button>
        </div>
        <div class="header-right">
          <Dropdown v-if="currentUser != null && currentUser.role && currentUser.role.length > 1">
            <!--<Dropdown v-if="$store.state.systemUser != null && $store.state.systemUser.role && $store.state.systemUser.role.length > 1">-->
            <Button type="text" icon="ios-browsers" style="color: white" size="large">
              系统切换
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem><router-link replace to="/main">管理员系统</router-link></DropdownItem>
              <DropdownItem><router-link replace to="/doctor_manage">医生系统</router-link></DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Button type="text" icon="md-exit" class="btn-blue" size="large" @click="quit">退出系统</Button>
        </div>
      </div>
    </Header>
    <Layout>
      <router-view/>
    </Layout>
  </Layout>
</template>

<script>
  export default {
    name: "doctor_main",
      data() {
          return {
              currentUser: null
          }},
      created() {
          this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
      },
    methods: {
      quit() {
        this.$http.post('system/logout').then(
          function (res) {
            let msg = res.body
            if (msg.success) {
              this.$Notice.success({title: '退出成功'});
              this.$store.commit('setSystemUser', null)
              this.$router.push('/')
            } else {
              this.$Notice.error({title: '退出失败', desc: msg.message});
            }
          }, function (res) {
            this.$Notice.error({title: '服务器异常，退出失败'});
          }
        )
      },
    }
  }
</script>

<style scoped>
  .layout-header-bar {
    background: #fff;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    z-index: 20;
    width: 100%;
  }

  .header-wapper {
    display: flex;
    align-tems: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
    box-shadow: 0 2px 1px 1px rgba(100, 100, 100, 0.1);
    background: #0e64c3;
    color: #fff;
  }

  .header-left {
    margin-left: 20px;
    display: flex;
    align-items: center;
  }

  .header-title {
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold
  }

  .header-right {
    margin-right: 20px;
  }

  .btn-blue {
    color: #fff;
  }

  .ivu-btn-text:hover {
    background-color: rgba(255, 255, 255, .2) !important;
  }
</style>
